import React from "react";
import { MapPin, ShieldCheck, FileCheck2, Repeat, UserCheck, BadgeCheck } from "lucide-react";

const ICONS = { MapPin, ShieldCheck, FileCheck2, Repeat, UserCheck, BadgeCheck };

const SIGNALS = [
  {
    icon: "MapPin",
    title: "Delaware-domiciled",
    description:
      "Small business headquartered at 800 N. King Street, Wilmington. Local prime capable and in-state accountable.",
  },
  {
    icon: "ShieldCheck",
    title: "Cleared personnel",
    description:
      "Engineers eligible for Public Trust and Secret. IL5-eligible on subcontract with cleared program managers.",
  },
  {
    icon: "FileCheck2",
    title: "Fixed-fee outcomes",
    description:
      "Acceptance criteria on every SOW. Time-and-materials only for advisory work — no burn-rate surprises.",
  },
  {
    icon: "Repeat",
    title: "Rollback on every wave",
    description:
      "Zero-downtime cutovers with reversible-by-design architecture. If a wave misbehaves, we roll back in minutes.",
  },
  {
    icon: "UserCheck",
    title: "Direct leadership access",
    description:
      "Named principals on every engagement — CTO, Compliance Director, PM in your standups. No junior offshoring.",
  },
  {
    icon: "BadgeCheck",
    title: "Continuous ATO record",
    description:
      "Every wave documented against NIST SP 800-53 Rev.5. Forty-seven waves shipped, 100% audit-ready posture.",
  },
];

export default function WhyDelaware({ SectionHeader }) {
  return (
    <section id="why" className="relative py-24 md:py-32 px-6 md:px-10">
      <div className="max-w-[1400px] mx-auto">
        <SectionHeader
          index="01"
          kicker="Why Delaware Trusts Eco Sweeps"
          title="Built for Delaware. Cleared for the mission."
          description="Public sector modernization is not a place to experiment with an unknown vendor. Six reasons agencies and primes route their work through us — not through an unnamed integrator two coasts away."
        />

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-800/60 border border-slate-800/60 reveal">
          {SIGNALS.map((s, i) => {
            const Icon = ICONS[s.icon] || ShieldCheck;
            return (
              <div key={s.title} className="bg-slate-950 hover:bg-slate-900/70 transition-colors p-7 group">
                <div className="flex items-start justify-between mb-6">
                  <span className="font-mono text-[10px] tracking-widest text-slate-500">{String(i + 1).padStart(2, "0")}</span>
                  <Icon size={20} strokeWidth={1.4} className="text-cyan-300 group-hover:text-cyan-200 transition-colors" />
                </div>
                <div className="text-lg font-semibold text-slate-100 tracking-tight leading-snug mb-3">{s.title}</div>
                <p className="text-sm text-slate-400 leading-relaxed">{s.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
